import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CacheControlInterceptor implements HttpInterceptor {
  
  private readonly noCacheUrls = [
    '/assets/version.json',
    '/api/version',
    '/health',
    '/status'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo archivos del propio front (URL relativa). Las llamadas a la API son
    // absolutas y otro dominio: añadirles cabeceras fuerza un preflight CORS que
    // el ingress rechaza (rompía users/great-investor/status por contener '/status').
    if (/^https?:\/\//i.test(req.url)) {
      return next.handle(req);
    }

    const path = req.url.split('?')[0];
    const shouldPreventCache = this.noCacheUrls.some(url => path.endsWith(url));

    if (shouldPreventCache) {
      // Sin cabeceras: los parámetros únicos bastan para saltarse la caché.
      const noCacheRequest = req.clone({
        setParams: {
          '_t': Date.now().toString(), // Timestamp para evitar cache
          '_v': Math.random().toString(36).substr(2, 9) // Random string adicional
        }
      });
      
      return next.handle(noCacheRequest);
    }
    
    return next.handle(req);
  }
}
